<template><div class="ai-component-body"><p class="ai-text">{{ card.text }}</p></div></template>
<script>
import behavior from '@/ai/components/mixins/card-behavior'
export default { mixins: [behavior] }
</script>
<style scoped src="./cards.css"></style>
<style scoped>.ai-component-body { display: contents; }</style>
